import React, { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import {
  FileBusinessToPerson,
  FilePersonToPerson,
} from "../helper/FileVersions";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useUserLogin } from "../../../hooks";

interface MenuListProps {
  isOpen: boolean;
}

// Added interface for the custom color prop
interface ColorProps {
  $customColor?: string;
}

const FileVersionList = () => {
  const { customColor } = useUserLogin();
  const [isOpen, setIsOpen] = useState(false);

  const versions = [
    { id: 2, label: "v1 (Person as Sender)", value: "V1" },
    { id: 1, label: "v2 (Business as Sender)", value: "V2" },
  ];

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDownload = (version: any) => {
    switch (version) {
      case "V1":
        FilePersonToPerson();
        break;
      case "V2":
        FileBusinessToPerson();
        break;
      default:
        break;
    }
    setIsOpen(false);
  };

  return (
    <DropdownContainer ref={dropdownRef}>
      {/* Pass the customColor down as a transient prop */}
      <DropdownButton
        $customColor={customColor}
        onClick={() => setIsOpen(!isOpen)}
      >
        Download Template <MdKeyboardArrowDown size={16} />
      </DropdownButton>

      <MenuList isOpen={isOpen}>
        {versions.map((version) => (
          <DownloadItem
            key={version.id}
            $customColor={customColor} // Pass it here as well
            onClick={() => handleDownload(version.value)}
          >
            Download {version.label}
          </DownloadItem>
        ))}
      </MenuList>
    </DropdownContainer>
  );
};

export default FileVersionList;

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  font-family: "Poppins", sans-serif;
`;

// Accept the ColorProps interface and use the value (with a fallback)
const DropdownButton = styled.button<ColorProps>`
  background-color: ${(props) => props.$customColor || "#c01217"};
  color: white;
  padding: 7px 15px;
  font-size: 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MenuList = styled.ul<MenuListProps>`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  min-width: 240px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 4px 0 0 0;
  list-style: none;
  z-index: 10;
  display: ${(props) => (props.isOpen ? "block" : "none")};
`;

// Accept the ColorProps interface for the hover state
const DownloadItem = styled.li<ColorProps>`
  padding: 10px 16px;
  cursor: pointer;
  font-size: 12px;
  color: #333;
  transition: background 0.2s;

  &:hover {
    background-color: ${(props) => props.$customColor || "#c01217"};
    color: white;
  }

  &:active {
    background-color: #e9ecef;
  }
`;
